import Dropzone from "./Dropzone";
import Close from "./../../../images/upload-close.svg";
import { Spinner } from "react-bootstrap";

const getImageStatus = (loading, uploadedImg) => {
  if (loading) {
    return (
      <div className="spinner">
        <Spinner variant="dark" animation="border" role="status" />
      </div>
    );
  } else if (!uploadedImg) {
    return <div className="upload-img"></div>;
  }
};

export default function UploadImage({
  onImageDrop,
  uploadedImg,
  setUploadedImg,
  disabled,
  loading,
  titleNeeded
}) {
  return (
    <div className="col-post-right">
      <div className={`image-upload-box ${disabled || loading ? "open":''}`}>
        {titleNeeded === false ? null : <h3>Image</h3>}

        <div className="upload-image-cover">
          <Dropzone onDrop={onImageDrop} accept="image/*" disabled={disabled} />

          <ul className="upload-image-list">
            <li>
              {!uploadedImg ? (
                getImageStatus(loading, uploadedImg)
              ) : (
                <div className="upload-img">
                  <div className="image-box">
                    <img src={uploadedImg} alt="upload image" />
                  </div>
                  <div className="close-icon">
                    <button onClick={() => setUploadedImg("")}>
                      <img src={Close} alt="close icon" />
                    </button>
                  </div>
                </div>
              )}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
